enum DateOption {
    Today = 'today',
    Last7Days = 'last7Days',
    Last4Weeks = 'last4Weeks',
    Last3Months = 'last3Months',
    Last12Months = 'last12Months',
    MonthToDate = 'monthToDate',
    QuarterToDate = 'quarterToDate',
    YearToDate = 'yearToDate',
    AllTime = 'allTime',
    CustomDate = 'customDate',
}

enum ComparisonType {
    YearToDate = 'ytd',
    QuarterToDate = 'qtd',
    MonthToDate = 'mtd',
    Rolling = 'rolling',
    Today = 'dtd',
}

type DateOptions = {
    [key in DateOption]: {
        interval: 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | 'custom';
        buttonLabel: string;
        title: {
            current: string;
            past: string;
        };
        comparison_type: ComparisonType;
    } & DateOptionsDateRange;
};

interface DateOptionsDateRange {
    start_date: string;
    end_date: string;
}

export { DateOption, ComparisonType };
export type { DateOptions, DateOptionsDateRange };
